var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityCleaningRoom = function SvgFacilityCleaningRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154-80q-47.5 0-80.75-33.25T40-194q0-47.5 33.25-80.75T154-308q47.5 0 80.75 33.25T268-194q0 47.5-33.25 80.75T154-80Zm0-60q24 0 39-15t15-39q0-24-15-39t-39-15q-24 0-39 15t-15 39q0 24 15 39t39 15Zm134 60q11-13 19.5-29.5T320-140h114v-300q0-37.538-26.731-64.269Q380.538-531 343-531H142v163q-14 0-30.5 4T82-353v-238h125v-153q0-72 52-124t124-52q56 0 100 29t65 80l278 671h94v60H654v-60h110L489-786q-15-35-41.5-54.5T383-860q-48 0-82 34t-34 82v153h76.164Q406-591 450-547t44 107v360H288Zm0-256Z"
  })));
};
export default SvgFacilityCleaningRoom;